module.exports = __webpack_public_path__ + "static/media/vsr.b455f5a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/partners/vsr.jpg
// module id = 1129
// module chunks = 4